
import { TranslationRecord } from '../../types';

export const location: TranslationRecord = {
  // Location Section
  locationTitle: 'Prime Location',
  locationSubtitle: 'In the Heart of Thessaloniki',
  subtitle: 'Located in the vibrant city center with easy access to restaurants, shopping, and cultural attractions.',
  ourLocation: 'Our prime location puts you steps away from the best of Thessaloniki.',
  walkingDistance: 'Walking distance to major attractions',
  publicTransport: 'Excellent public transport connections',
  restaurantsNearby: 'Surrounded by top restaurants and cafes',
  shoppingNearby: 'Close to shopping districts',
  
  // Map and directions
  getDirections: 'Get Directions',
  viewOnMap: 'View on Map',
  address: 'Thessaloniki City Center',
  
  // Nearby attractions
  nearbyTitle: 'What\'s Nearby',
  nearbySubtitle: 'Discover the best of Thessaloniki around our suites',
  
  // New map-related translations
  exploreLocation: 'Explore Our Location',
  interactiveMap: 'Interactive Location Map',
  walkingDistanceFrom: 'Walking distance from Loena Suites',
  minutesWalk: 'minutes walk',
  allCategories: 'All',
  restaurants: 'Restaurants',
  landmarks: 'Landmarks',
  shopping: 'Shopping',
  everythingWalkable: 'Everything Within Walking Distance',
  walkableDescription: 'From your doorstep, all of Thessaloniki\'s main attractions, restaurants, and shops are within walking distance. No taxi needed - just walk and explore!'
};
